import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { RootState, selectUserLoggedIn } from '../../modules';
import {
    selectCancelOrderLoading,
    selectStockOpenOrderData,
    selectStockOpenOrderLoading,
    selectUpdateOrderLoading,
} from '../../modules/user/stock-order/selector';
import { Button, Empty, Input, Spin } from 'antd';
import { AntdTable } from '../../components/AntdTable';
import { AntdModal } from '../../components/AntdModal';
import { fetchCancelOrderRequest, fetchUpdateOrderRequest } from '../../modules/user/stock-order/actions';
import { OpenOrderData } from '../../modules/user/stock-order/types';
import { Link } from 'react-router-dom';

const OpenOrder = () => {
    const isLogin = useSelector((state: RootState) => selectUserLoggedIn(state));
    const openOrder = useSelector((state: RootState) => selectStockOpenOrderData(state));
    const openOrderLoading = useSelector((state: RootState) => selectStockOpenOrderLoading(state));
    const [openCancelModal, setOpenCancelModal] = useState(false);
    const [openUpdateModal, setOpenUpdateModal] = useState(false);
    const [selectedOrder, setSelectedOrder] = useState<OpenOrderData>();
    const dispatch = useDispatch();
    const cancelLoading = useSelector((state: RootState) => selectCancelOrderLoading(state));
    const updateLoading = useSelector((state: RootState) => selectUpdateOrderLoading(state));
    // console.log(updateLoading)
    const handleCancelOrder = () => {
        if (selectedOrder) {
            dispatch(fetchCancelOrderRequest({ id: selectedOrder.id, ticker: selectedOrder.ticker }));
        }
    };
    const showModal = (cancelOrder: OpenOrderData, action: 'cancel' | 'update') => {
        if (action === 'cancel') {
            setOpenCancelModal(true);
            setSelectedOrder(cancelOrder);
        }
        if (action === 'update') {
            setOpenUpdateModal(true);
            setSelectedOrder(cancelOrder);
        }
    };
    const cancelModal = (action: 'cancel' | 'update') => {
        if (action === 'cancel') {
            setOpenCancelModal(false);
        }
        if (action === 'update') {
            setOpenUpdateModal(false);
        }
        setSelectedOrder(undefined);
    };
    useEffect(() => {
        if (!cancelLoading) {
            setOpenCancelModal(false);
            setSelectedOrder(undefined);
        }
    }, [cancelLoading]);

    useEffect(() => {
        if (!updateLoading) {
            setOpenUpdateModal(false);
            setSelectedOrder(undefined);
        }
    }, [updateLoading]);

    const handleUpdateOrder = () => {
        if (selectedOrder) {
            dispatch(
                fetchUpdateOrderRequest({
                    orderId: selectedOrder.id,
                    orderInfo: {
                        ticker: selectedOrder.ticker,
                        type: selectedOrder.type,
                        side: selectedOrder.side,
                        totalAmount: Number(selectedOrder.totalAmount),
                        price: Number(selectedOrder.price),
                    }
                }),
            );
        }
    };
    const columns = [
        {
            title: 'Side',
            dataIndex: 'side',
            key: 'side',
            render: (text: any) => (
                <span
                    style={{
                        color: text === 'buy' ? 'rgb(58, 204, 138)' : 'rgb(223, 95, 103)',
                    }}>
                    {text}
                </span>
            ),
        },
        {
            title: 'Amount',
            dataIndex: 'totalAmount',
            key: 'totalAmount',
            render: (value: any) => {
                return (
                    <span style={{ color: 'var(--primary-text-color-main)' }}>{Number(value).toLocaleString()}</span>
                );
            },
        },
        {
            title: 'Price',
            dataIndex: 'price',
            key: 'price',
            render: (value: any) => {
                return (
                    <span style={{ color: 'var(--primary-text-color-main)' }}>{Number(value).toLocaleString()}</span>
                );
            },
        },
        {
            title: 'Total(VND)',
            dataIndex: 'totalPrice',
            key: 'totalPrice',
            render: (_: any, record) => {
                return (
                    <span style={{ color: 'var(--primary-text-color-main)' }}>{(Number(record.price) * Number(record.totalAmount)).toLocaleString()}</span>
                );
            }
        },
        {
            title: 'Filled',
            dataIndex: 'filledAmount',
            key: 'filledAmount',
            render: (value: any) => {
                return (
                    <span style={{ color: 'var(--primary-text-color-main)' }}>{Number(value).toLocaleString()}</span>
                );
            },
        },
        {
            title: 'Status',
            dataIndex: 'status',
            key: 'status',
            render: (text: any) => (
                <span
                    style={{
                        color: '#FFA500',
                        textTransform: 'capitalize',
                    }}>
                    {text}
                </span>
            ),
        },
        {
            title: 'Action',
            key: 'action',
            render: (record: any) => (
                <div className='desktop-open-order_action'>
                    <Button key={record.id} onClick={() => showModal(record, 'cancel')} danger ghost>
                        Cancel
                    </Button>
                    <Button key={record.id} onClick={() => showModal(record, 'update')} ghost >
                        Update
                    </Button>
                </div>


            ),
        },
    ];

    return (
        <div className="desktop-open-order">
            {isLogin ? (
                openOrderLoading ? (
                    <Spin />
                ) : openOrder?.length === 0 ? (
                    <Empty />
                ) : (
                    <AntdTable
                        title={() => 'Open Orders'}
                        pagination={false}
                        columns={columns}
                        dataSource={openOrder}
                        rowKey="id"
                    />
                )
            ) : (
                <div className="desktop-open-order_login">
                    <p>
                        <Link to={'/signin'}>Register/Login</Link>
                    </p>
                </div>
            )}
            <AntdModal
                title="Update order price"
                open={openUpdateModal}
                onCancel={() => cancelModal('update')}
                onOk={handleUpdateOrder}
                loading={updateLoading}

            >
                <div>
                    <Input
                        placeholder="Enter new price"
                        type="number"
                        style={{ width: '100%' }}
                        onChange={(e) => {
                            if (selectedOrder) {
                                setSelectedOrder({ ...selectedOrder, price: e.target.value });
                            }
                        }}
                        value={Number(selectedOrder?.price)}
                    />
                </div>
            </AntdModal>
            <AntdModal
                title="Are you sure to cancel this order?"
                open={openCancelModal}
                onCancel={() => cancelModal('cancel')}
                onOk={handleCancelOrder}
                loading={cancelLoading}
            />
        </div>
    );
};

export default OpenOrder;
